import { createBrowserHistory } from 'history'
// Need to import types from history
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/14062

// Using history object outside a component
//https://brandoncantello.medium.com/using-history-to-navigate-your-react-app-from-outside-a-component-40ea74ba4402
export default createBrowserHistory()
